import Task from '@/classes/task/Task';
import { TaskResponse } from '@/classes/task/types';
import { HttpMethod } from '@/types/HttpMethods';
import { accountingSheet } from '@/utils/config';
import { UpdateAccountingSheetData } from './types';

class AccountingSheetController {
  public static async loadSingle(sheetId: number): Promise<TaskResponse> {
    const url = `${accountingSheet.accountingSheetSingle}?id=${sheetId}`;
    const result = await Task.execute({ url, method: HttpMethod.GET });
    return result;
  }

  public static async statusApproveByControlling(sheetId: number): Promise<TaskResponse> {
    const url = accountingSheet.status.processControlling;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId } });
    return result;
  }

  public static async statusApproveByAccountant(sheetId: number): Promise<TaskResponse> {
    const url = accountingSheet.status.processAccountant;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId } });
    return result;
  }

  public static async statusPaymentDoneByAccountant(sheetId: number): Promise<TaskResponse> {
    const url = accountingSheet.status.processAccountantPaymentDone;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId } });
    return result;
  }

  public static async statusChange(sheetId: number, status: string): Promise<TaskResponse> {
    const url = accountingSheet.status.change;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId, status } });
    return result;
  }

  public static async update(data: UpdateAccountingSheetData): Promise<TaskResponse> {
    const url = accountingSheet.accountingSheetUpdate;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: data });
    return result;
  }

  public static async cancel(sheetId: number, comment: string): Promise<TaskResponse> {
    const url = accountingSheet.status.cancel;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId, comment } });
    return result;
  }

  public static async supplierChangesAccept(sheetId: number, comment: string): Promise<TaskResponse> {
    const url = accountingSheet.status.supplierChangesAccept;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId, comment } });
    return result;
  }

  public static async supplierChangesReject(sheetId: number, comment: string): Promise<TaskResponse> {
    const url = accountingSheet.status.supplierChangesReject;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId, comment } });
    return result;
  }

  public static async packageReject(sheetId: number, comment: string): Promise<TaskResponse> {
    const url = accountingSheet.status.packageReject;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId, comment } });
    return result;
  }

  public static async packageUnblock(sheetId: number): Promise<TaskResponse> {
    const url = accountingSheet.status.packageUnblock;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId } });
    return result;
  }

  public static async supplierChangesUnblock(sheetId: number, objectName: string): Promise<TaskResponse> {
    const url = accountingSheet.status.supplierChangesUnblock;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId, objectName } });
    return result;
  }

  public static async supplierChangesPermission(): Promise<TaskResponse> {
    const url = accountingSheet.status.supplierChangesPermission;
    const result = await Task.execute({ url, method: HttpMethod.GET });
    return result;
  }

  public static async recall(sheetId: number): Promise<TaskResponse> {
    const url = accountingSheet.status.recall;
    const result = await Task.execute({ url, method: HttpMethod.PUT, body: { sheetId } });
    return result;
  }

  public static async sign(sheetId: number): Promise<TaskResponse> {
    const url = accountingSheet.status.sign;
    const result = await Task.execute({ url, method: HttpMethod.POST, body: { sheetId } });
    return result;
  }
}

export default AccountingSheetController;
